
// SVG Icon: geolocation
export default { id: "terriajs-geolocation" };
export const id = "terriajs-geolocation";
export const name = "geolocation";
